// shelbulaworkspaces/ContextMenu.jsx
import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ContextMenu = ({ x, y, show, onClose, actions, targetNode }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    if (!show) return null;

    const menuStyle = {
        top: y,
        left: x,
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    ref={menuRef}
                    style={menuStyle}
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.1 }}
                    className="fixed z-[1002] w-52 bg-surface border border-border-color rounded-md shadow-lg p-1"
                >
                    <ul>
                        {actions.map((action, index) => {
                             if (action.separator) {
                                return <li key={`sep-${index}`}><div className="h-px bg-border-color my-1" /></li>;
                            }

                            if (action.kind === 'header') {
                                return (
                                    <li key={index} className="px-3 py-2">
                                        <div className="text-[11px] font-semibold text-on-surface truncate">{action.label}</div>
                                        {action.description ? (
                                            <div className="mt-0.5 text-[10px] text-on-surface-dim truncate">{action.description}</div>
                                        ) : null}
                                    </li>
                                );
                            }

                            if (action.kind === 'meta') {
                                return (
                                    <li key={index} className="px-3 py-2 flex items-center justify-between gap-3">
                                        <span className="text-[10px] uppercase tracking-[0.12em] text-on-surface-dim">{action.label}</span>
                                        <span className="min-w-0 text-right text-[11px] text-on-surface truncate">
                                            {action.valueNode || action.value}
                                        </span>
                                    </li>
                                );
                            }

                            return (
                                <li key={index}>
                                    <button
                                        onClick={() => {
                                            action.onClick(targetNode);
                                            onClose();
                                        }}
                                        className="w-full text-left flex items-center gap-3 px-3 py-1.5 text-sm rounded hover:bg-surface-dark text-on-surface transition-colors"
                                    >
                                        {action.icon}
                                        <span>{action.label}</span>
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ContextMenu;